import { ContentLoader } from '@marketplace-web/shared/ui-helpers/server'

const HomeLoader = () => {
  return (
    <ContentLoader size="large" styling={ContentLoader.Styling.Tight} testId="homepage-loader" />
  )
}

export default HomeLoader
